import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React, { Component } from "react";
import ImageActionCreators from "../../controller/action/ImageActionCreators";
import ImageStoreInstance from "../../controller/store/ImageStore";
import LoadingComponent from "../utils/LoadingComponent";

interface PropsInterface {
  handleSelectImage: (url: string) => void;
  handleAddImage: (url: string) => void;
}

interface StateInterface {
  imagesUrl: string[];
  isOpen: boolean;
  isLoading: boolean;
}

export default class ImagePickerModalComponent extends Component {
  public props: PropsInterface;
  public state: StateInterface;

  private inputFileRef: React.RefObject<HTMLInputElement>;

  constructor(props: any) {
    super(props);
    this.state = {
      imagesUrl: ImageStoreInstance.images,
      isOpen: false,
      isLoading: false,
    };
    this.props = props;
    this.inputFileRef = React.createRef();
    this.openModal = this.openModal.bind(this);
    this.onStoreChanged = this.onStoreChanged.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleSelectImage = this.handleSelectImage.bind(this);
    this.handleClickAddImage = this.handleClickAddImage.bind(this);
  }

  onStoreChanged() {
    const images = ImageStoreInstance.images;
    this.setState({ imagesUrl: images });
  }

  componentDidMount() {
    ImageStoreInstance.addChangeListener(this.onStoreChanged);
  }

  componentWillUnmount() {
    ImageStoreInstance.removeChangeListener(this.onStoreChanged);
  }

  public openModal() {
    this.setState({ isOpen: true });
  }

  public handleCloseModal(_e?: any) {
    this.setState({ isOpen: false });
  }

  private handleClickAddImage(_e?: any) {
    this.inputFileRef.current?.click();
  }

  private handleSelectImage(files: FileList | undefined | null) {
    this.setState({ isLoading: true });
    ImageActionCreators.addImageToBucket(files!)
      .then(() => {
        this.setState({ isLoading: false });
      })
      .catch((err) => {
        console.warn(err);
        this.setState({ isLoading: false });
      });
  }

  render() {
    return (
      <div style={{ overflow: "scroll" }}>
        <Dialog fullWidth={true} maxWidth={"md"} open={this.state.isOpen}>
          <DialogTitle>Selectionné l'image du produit :</DialogTitle>
          <DialogContent>
            <div>
              <input
                ref={this.inputFileRef}
                onChange={(_e) => {
                  this.handleSelectImage(this.inputFileRef.current?.files);
                }}
                type="file"
                style={{ display: "none" }}
              />
            </div>
            {this.state.isLoading ? (
              <LoadingComponent isOpen={this.state.isLoading} />
            ) : (
              <div style={{ marginLeft: "10%", width: "80%", display: "flex" }}>
                {this.state.imagesUrl.map((aUrl, i) => {
                  return (
                    <div
                      style={{
                        width: "200px",
                        height: "200px",
                        margin: "10px",
                      }}
                      key={i}
                    >
                      <img
                        style={{ width: "100%", height: "100%" }}
                        src={aUrl}
                        alt=""
                        onClick={(e) => {
                          this.props.handleAddImage((e.target as any).src);
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={this.handleCloseModal}>
              Annuler
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleClickAddImage}
            >
              Ajouter une image
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
